"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_countdown_1 = __importStar(require("react-countdown"));
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var countdown_module_scss_1 = __importDefault(require("./countdown.module.scss"));
var ImageLink_1 = __importDefault(require("../../../../components/ImageLink"));
var react_i18next_1 = require("react-i18next");
var CountdownComp = function (_a) {
    var type = _a.type, eventDate = _a.eventDate, eventBg = _a.eventBg;
    // Renderer callback with condition
    var renderer = function (_a) {
        var days = _a.days, hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("h6", { children: [days, "d", (0, jsx_runtime_1.jsx)("span", { children: " : " }), (0, react_countdown_1.zeroPad)(hours), "h", (0, jsx_runtime_1.jsx)("span", { children: " : " }), (0, react_countdown_1.zeroPad)(minutes), "m", (0, jsx_runtime_1.jsx)("span", { children: " : " }), (0, react_countdown_1.zeroPad)(seconds), "s"] }) }));
    };
    var currentTime = moment_timezone_1.default.tz("America/Los_Angeles").valueOf();
    var genTime = function (time) {
        return (0, moment_timezone_1.default)(time)
            .add((0, moment_timezone_1.default)(time).utcOffset(), "minutes")
            .valueOf();
    };
    var startTime = genTime(moment_timezone_1.default.tz("America/Los_Angeles").format(eventDate));
    var beforeEventStart = currentTime < startTime;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: countdown_module_scss_1.default.countdown, style: { backgroundImage: "url(".concat((0, ImageLink_1.default)(eventBg), ")") } }, { children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h3", { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: type == "event" ? "creatorEventCountdown" : "creatorNFTCountdown" }) }), (0, jsx_runtime_1.jsx)("div", __assign({ className: countdown_module_scss_1.default.time }, { children: (0, jsx_runtime_1.jsx)(react_countdown_1.default, { date: beforeEventStart ? startTime : new Date(), renderer: renderer }) }))] }) })) }));
};
exports.default = CountdownComp;
